"use client";

import { useRouter } from "next/navigation";
import { ColorSwatchGroup } from "@/scott/ui/elements/color-swatch/color-swatch";
import { TextD2C } from "@/scott/ui/elements/text-d2c/text";
import { useVariantSwitch } from "./product-variant-switch-context";

export interface ProductColorSelectorOption {
  id: string;
  label: string;
  colors: string[];
  href: string;
  /** Article code the swatch resolves to, used for client-side switching. */
  articleCode?: string;
  selected: boolean;
}

export interface ProductColorSelectorProps {
  label: string;
  value?: string;
  options: ProductColorSelectorOption[];
}

export function ProductColorSelector(
  props: Readonly<ProductColorSelectorProps>
) {
  const router = useRouter();
  const switchVariant = useVariantSwitch();

  if (props.options.length === 0) {
    return null;
  }

  const selectedOption = props.options.find((option) => option.selected);

  return (
    <div className="space-y-3">
      <TextD2C style="bold" variant="p-small">
        {props.label}
        {props.value ? `: ${props.value}` : ""}
      </TextD2C>
      {props.options.length > 1 && (
        <ColorSwatchGroup
          className="w-full"
          onSelect={(id) => {
            const option = props.options.find((item) => item.id === id);

            if (!option?.href) {
              return;
            }

            // Inside the hero switcher: swap client-side (no catalogue refetch).
            if (switchVariant && option.articleCode) {
              switchVariant(option.articleCode, option.href);
              return;
            }

            router.push(option.href, { scroll: false });
          }}
          selectedId={selectedOption?.id}
          swatches={props.options.map((option) => ({
            id: option.id,
            label: option.label,
            colors: option.colors,
          }))}
        />
      )}
    </div>
  );
}
